declare var Vue: any;
declare var Vuetify: any;

/* Locales */
// declare var en;
// declare var fa;

namespace Vit {
    export class SergenPanel extends Serenity.Widget<any> {
        constructor(container: JQuery) {
            let vm: any;
            super(container);

            const rtl = document.documentElement.dir === "rtl";
            vm = new Vue({
                el: $("<div />").appendTo(this.element)[0],
                mounted() {
                    this.onResize();
                    window.addEventListener("resize", this.onResize, {passive: true,});
                },
                // updated() {
                //     if (!this.views) {
                //         return;
                //     }
                //
                //     debugger;
                //
                //     // const
                // },
                beforeDestroy() {
                    if (typeof window !== "undefined") {
                        // @ts-ignore
                        window.removeEventListener("resize", this.onResize, {passive: true,});
                    }
                },
                vuetify: new Vuetify({
                    // lang: {
                    //     current: Q.Culture.shortName,
                    //     locales: { en, fa },
                    // },
                    rtl: rtl,
                }),
                data: {
                    isMobile: false,
                    connection: "",
                    connections: [],
                    module: "",
                    table: null,
                    tables: [],
                    filterTable: "",
                    generate: {
                        Row: true,
                        Service: true,
                        UI: true,
                    },
                    data: [],
                    views: null,
                    // rootNodes: [1,],
                    properties: [],
                    currentProperty: {},
                    rtl,
                    locale: `${Q.Culture.language}`,
                    previewDialog: false,
                    previewSize: "desktop",
                },
                computed: {
                    filteredTables: function () {
                        return this.tables.filter(table => table.Identifier.toLowerCase()
                            .includes(this.filterTable.toLowerCase()));
                    },
                },
                watch: {
                    connection: function (value) {
                        if (typeof value !== "string" || !value.trim()) {
                            vm.tables = [];
                            vm.table = null;
                            vm.data = [];
                            vm.views = null;
                            vm.properties = [];
                            vm.currentProperty = {};
                        } else {
                            SergenService.ListTables({
                                ConnectionKey: value,
                            }, response => {
                                vm.tables = response.Entities;
                                vm.module = value;
                            });
                        }
                    },
                },
                methods: {
                    forceUpdate: function () {
                        this.$forceUpdate();
                    },
                    log: function (value: any, key?: any) {
                        console.log(((key) ? `${key}: ` : "") + value);
                    },
                    onResize() {
                        this.isMobile = window.innerWidth < 600;
                    },
                    generateAll: function () {
                        if (!this.connection.trim()) {
                            Q.notifyError("");

                            return;
                        }

                        SergenService.GenerateAll({
                            ConnectionKey: this.connection,
                            Module: this.module,
                            GenerateOptions: this.generate,
                        }, r => {
                            Q.notifySuccess("Code for selected connection is generated. You'll need to rebuild your project.");
                        });
                    },
                    backToTableView: function () {
                        if (!this.views) {
                            Q.notifyError("Access denied method!");

                            return;
                        }

                        this.table = null;
                        this.data = [];
                        this.views = null;
                        this.properties = [];
                        this.currentProperty = {};
                    },
                    updateView: function (event, callback, params = []) {
                        if (!this.connection) {
                            Q.notifyError("");

                            return;
                        }

                        if (!this.table || !this.table.Tablename) {
                            Q.notifyError("");

                            return;
                        }

                        SergenManager.current.save(() => {
                            Q.notifySuccess("Customize view for selected table is successful. You'll need to generate code to update your project.");

                            if (callback) {
                                callback(...params);
                            }

                            vm.backToTableView();
                        }, (e) => {
                            Q.notifyError(e);
                        });
                    },
                    CustomizeView: function (table: SergenTable) {
                        SergenService.ListUIs({
                            ConnectionKey: this.connection,
                            TableKey: table.Tablename,
                        }, (response) => {
                            this.table = table;
                            response.Name = table.Tablename;
                            SergenManager.Create(this.connection, response);
                            vm.data = response;
                            vm.views = SergenManager.current.nodes;
                        });
                    },
                    showProperties: function (values) {
                        if (!values.length) {
                            this.properties = [];
                            this.currentProperty = {};

                            return;
                        } else if (values.length > 1) {
                            Q.notifyError("Must select 1 item at the same time");
                            this.properties = [];
                            this.currentProperty = {};

                            return;
                        }

                        this.properties = ((typeof values[0] === "object") ? values[0] : Vit.SergenNodeBase.Get(values[0])).getProperties();

                        window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: "smooth",
                        });
                    },
                    getItemValue: function (data) {
                        let tempOpt = "";

                        if (!data) {
                            return tempOpt;
                        }

                        if (data.value != null) {
                            tempOpt = data.value;
                        }

                        if (!data.lookupValues || !data.lookupValues.length) {
                            return tempOpt;
                        }

                        const lookupItem = data.lookupValues.find((item) => item.key === data.value);

                        return (lookupItem) ? lookupItem.value : "";
                    },
                    appendModel: function (item, type) {
                        if (!(item instanceof Vit.SergenDataNode)) {
                            return;
                        }

                        switch (type) {
                            case "form":
                                item.AddFormUI();

                                break;
                            case "grid":
                                item.AddGridUI();

                                break;
                            default:
                                Q.notifyError("Invalid type!");

                                return;
                        }
                    },
                    removeModel: function (item) {
                        if (!item || !(item instanceof Vit.SergenUINode || item instanceof Vit.SergenFieldNode)) {
                            return;
                        }

                        item.Remove();
                    },
                    // addField: function (item: SergenGridUINode | SergenFormUINode) {
                    //     if (!item) {
                    //         return;
                    //     }
                    //
                    //     if (item instanceof Vit.SergenGridUINode || item instanceof Vit.SergenFormUINode) {
                    //         // @ts-ignore
                    //         item.AddField();
                    //     }
                    // },
                    previewItem: function (item) {
                        /* TODO: Sort uiModel */
                        this.previewDialog = true;
                        (function (model) {
                            setTimeout(() => {
                                const iframe = document.querySelector("#preview iframe");

                                if (!iframe) {
                                    return;
                                }

                                /* TODO: Fix firefox bug */
                                // @ts-ignore
                                iframe.contentWindow.location.reload(true);
                                // @ts-ignore
                                iframe.onload = function () {
                                    this.contentWindow.showPreview(model);
                                };
                            });
                        })(item.uiModel);
                    },
                    setCurrentProperty: function (item) {
                        if (!item.editor) {
                            this.currentProperty = {};

                            return;
                        }

                        this.currentProperty = item;
                    },
                    validateField: function (value) {
                        if (!("validate" in this.currentProperty)) {
                            return true;
                        }

                        return this.currentProperty.validate(value) || true;
                    },
                    setPreviewSize: function (item) {
                        const previewBox = document.querySelector("#preview");

                        if (!previewBox) {
                            return;
                        }

                        switch (item) {
                            case "desktop":
                                // @ts-ignore
                                previewBox.style.cssText = "";

                                break;
                            case "tablet":
                                // @ts-ignore
                                previewBox.style.cssText = "width: 768px;";

                                break;
                            case "mobile":
                                // @ts-ignore
                                previewBox.style.cssText = "width: 425px;";

                                break;
                            default:
                                Q.notifyError("Invalid device size!");
                        }
                    },
                    restorePreview: function (active) {
                        const previewBox = document.querySelector("#preview");

                        if (!previewBox) {
                            return;
                        }

                        this.previewSize = "desktop";
                        // @ts-ignore
                        previewBox.style.cssText = "";
                    },
                },
                template: Q.getTemplate("Administration.SergenPanel"),
            });

            SergenService.ListConnections({}, response => vm.connections = response.Entities);
        }
    }
}